import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from "@angular/core";

@Directive({
  selector: "[CheckboxColorChange]",
})
export class CheckboxColorChangeDirective implements OnChanges {
  @Input() CheckboxColorChange: string = "50a5f1";

  domStyle: HTMLElement;

  constructor(private eleRef: ElementRef, private renderer2: Renderer2) {
    this.domStyle = this.renderer2.createElement('style');
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    const className = `custom-directive-${this.CheckboxColorChange}`;
    this.domStyle.textContent = `
    .${className} {}
    .${className}::before {
      box-shadow: inset 20px 20px #${this.CheckboxColorChange};
      }
      `;
    this.renderer2.addClass(this.eleRef.nativeElement, className);
      this.renderer2.appendChild(document.head, this.domStyle);
  }
}
